import type { PublicPortadaSlot } from '@ahora-patagonia/contracts';
import { NotaUnicaB } from './PortadaCeldas.js';

export interface PortadaBProps {
  slots: PublicPortadaSlot[];
}

/**
 * Maqueta B — nota única: una sola nota toma todo el frente del diario y **debajo no hay más
 * portada**. Lo siguiente del cuerpo es el aviso horizontal bajo la portada, si hay campaña, y
 * después el primer bloque de categoría.
 *
 * No hay grilla que armar: es una celda a ancho completo del contenido —en escritorio, incluido el
 * ancho de la columna lateral, porque el frente corre por encima de ella (ver `HomeView`)—. Por eso
 * tampoco tiene `parte="resto"`: en B no queda nada abajo.
 *
 * Si la posición 1 está vacía **no hay portada**, y el bloque ni siquiera llega: el servidor no lo
 * emite (handoff §5). Acá el `null` se contempla igual, porque un componente que asume que sus
 * datos vinieron completos es un componente que rompe la home el día que no vinieron.
 */
export function PortadaB({ slots }: PortadaBProps) {
  const unica = slots.find((s) => s.position === 1)?.nota ?? null;
  if (!unica) return null;
  return <NotaUnicaB nota={unica} />;
}
